import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'rsuite';
import { InventoryAvailabilityType } from '../../../../interfaces/inventory';
import InventoryItemAvailability from '../../ItemAvailability';

const AvailabilityPopover = ({ availability, ...props }) => (
  <Popover title="Availability by Location" {...props}>
    <InventoryItemAvailability availability={availability} canDelete />
  </Popover>
);

AvailabilityPopover.propTypes = {
  availability: PropTypes.arrayOf(InventoryAvailabilityType).isRequired
};

export default AvailabilityPopover;
